// extracted by mini-css-extract-plugin
export default {"active":"download_active__C-Pws","inactive":"download_inactive__Cn4t-","thumbnail":"download_thumbnail__+jaLz"};